module.exports = __webpack_public_path__ + "static/media/af.94ffd058.svg";